var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"positionfixed3"},[_c('div',{staticClass:"DeepDesign"},[_c('div',{staticClass:"DeepDesign_content"},[_c('ImageModal',{attrs:{"imageUrl":_vm.imageUrl}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }